
















import { defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export default defineComponent({
  props: {
    logoUrl: {
      type: String,
      default: '',
    },
    rightPaneMessage: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      t,
    };
  },
});
